"use client";

import Tooltip from "@casino/legacyUi/Tooltip";
import { useGamePageData } from "@casino/ui/Games/hooks";
import { GameControlsLikes } from "@workspace/frontend-ui";
import type { FC } from "react";
import useVote from "./hooks/useVote";

type Props = {
  gameId?: string;
  likes?: number;
  isLiked?: boolean;
};

const LikeButton: FC<Props> = ({ gameId, likes = 0, isLiked = false }) => {
  const vote = useVote({ gameId, likes, isLiked });
  const { t } = useGamePageData();

  const label = vote.isLiked
    ? t("game.controls.like.remove", "Remove your like")
    : t("game.controls.like.add", "Like this game");

  return (
    <Tooltip
      open={vote.needsPlayFirst}
      onOpenChange={(open) => !open && vote.dismissPlayFirstMessage()}
    >
      <Tooltip.Trigger>
        <GameControlsLikes
          data-testid="like-button"
          aria-label={label}
          likes={vote.likes}
          isAlreadyLiked={vote.isLiked}
          onClick={vote.submitVote}
        />
      </Tooltip.Trigger>
      {vote.needsPlayFirst && (
        <Tooltip.Content>
          {t("game.controls.like.needsplayfirst", "You need to play first")}
        </Tooltip.Content>
      )}
    </Tooltip>
  );
};

export default LikeButton;
